import { render, staticRenderFns } from "./ArtsAdmin.vue?vue&type=template&id=497cfd78&"
import script from "./ArtsAdmin.vue?vue&type=script&lang=js&"
export * from "./ArtsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports